import getDefaultState from './stateInitializer'

export default getDefaultState()
